import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=85a8c54a&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=85a8c54a&scoped=true&lang=css&"
import style2 from "./MainLayout.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a8c54a",
  null
  
)

export default component.exports